<template>
  <validation-provider :rules="rules" :name="name" v-bind="$attrs" v-slot="{errors, failedRules, valid, invalid, validated}">
    <div :class="wrapperClass">
      <slot name="label">
        <label v-if="label" :class="labelClasses">
          {{label}} <span v-if="required" class="text-danger">*</span>
        </label>
      </slot>
      <div :class="[
       {'input-group': hasIcon},
       {'focused': focused},
       {'input-group-alternative': alternative},
       {'has-label': label || $slots.label},
       inputGroupClasses
       ]">
        <div v-if="prependIcon || $slots.prepend" class="input-group-prepend">
        <span class="input-group-text">
          <slot name="prepend">
            <i :class="prependIcon"></i>
          </slot>
        </span>
        </div>
        <slot v-bind="slotData">
          <base-inner-input
            :mask="mask"
            :value="value"
            :type="type"
            v-on="listeners"
            v-bind="$attrs"
            :valid="valid"
            :min="min"
            :required="required"
            class="form-control"
            :style="inputStyle"
            :class="[{'is-valid': valid && validated && successMessage && !error}, {'is-invalid': (invalid || error) && validated}, inputClasses]"
            @change="updateValue"
            @blur="onBlur"
            @keydown="onKeyDown"
            @keyup="onkeyup"
            :max="max"
            :maxlength="max"
          />
        </slot>
        <div v-if="appendIcon || $slots.append" class="input-group-append" @click="$emit('append-click')">
          <span class="input-group-text">
              <slot name="append">
                  <i :class="appendIcon"></i>
              </slot>
          </span>
        </div>
        <slot name="infoBlock"></slot>
      </div>
      <slot name="success">
        <div class="valid-feedback" v-if="valid && validated && !error">
          {{successMessage}}
        </div>
      </slot>
      <slot name="error">
        <div v-if="error" class="invalid-feedback" style="display: block;">
          {{ error }}
        </div>
        <div v-else-if="failedRules['required']" class="invalid-feedback" style="display: block;">
          Este campo é obrigatório
        </div>
        <div v-else-if="failedRules['email']" class="invalid-feedback" style="display: block;">
          Este campo deve ser um email válido
        </div>
        <div v-else-if="errors[0]" class="invalid-feedback" style="display: block;">
          {{ errors[0] }}
        </div>
      </slot>
    </div>
  </validation-provider>
</template>
<script>
  import BaseInnerInput from './BaseInnerInput.vue';
  export default {
    components: { BaseInnerInput },
    inheritAttrs: false,
    name: "base-input",
    props: {
      mask: {
        type: String,
        default: 'none'
      },
      wrapperClass: {
        type: [String, Object],
        default: 'form-group',
      },
      required: {
        type: Boolean,
        description: "Whether input is required (adds an asterix *)"
      },
      min: {
        type: Number,
        description: "Whether input is required (adds an asterix *)"
      },
      max: {
        type: Number,
        description: "Whether input max value"
      },
      group: {
        type: Boolean,
        description: "Whether input is an input group (manual override in special cases)"
      },
      alternative: {
        type: Boolean,
        description: "Whether input is of alternative layout"
      },
      label: {
        type: String,
        description: "Input label (text before input)"
      },
      error: {
        type: String,
        description: "Input error (below input)"
      },
      successMessage: {
        type: String,
        description: "Input success message",
        default: ''
      },
      labelClasses: {
        type: String,
        description: "Input label css classes",
        default: "form-control-label"
      },
      inputClasses: {
        type: String,
        description: "Input css classes"
      },
      inputGroupClasses: {
        type: String,
        description: "Input group css classes"
      },
      value: {
        type: [String, Number],
        description: "Input value"
      },
      type: {
        type: String,
        description: "Input type",
        default: "text"
      },
      appendIcon: {
        type: String,
        description: "Append icon (right)"
      },
      prependIcon: {
        type: String,
        description: "Prepend icon (left)"
      },
      rules: {
        type: [String, Array, Object],
        description: 'Vee validate validation rules',
        default: ''
      },
      name: {
        type: String,
        description: 'Input name (used for validation)',
        default: ''
      },
      inputStyle: {
        type: String,
        description: 'Input custom stylization',
        default: ''
      },
      valid: {
        type: Boolean,
        description: 'Input name (used for validation)',
        default: true
      }
    },
    data() {
      return {
        focused: false
      };
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: this.updateValue,
          focus: this.onFocus,
          blur: this.onBlur
        };
      },
      slotData() {
        return {
          focused: this.focused,
          error: this.error,
          ...this.listeners
        };
      },
      hasIcon() {
        const { append, prepend } = this.$slots;
        return (
          append !== undefined ||
          prepend !== undefined ||
          this.appendIcon !== undefined ||
          this.prependIcon !== undefined ||
          this.group
        );
      }
    },
    methods: {
      updateValue(evt) {
        let value = (evt && evt.target && evt.target.value) || evt;
        this.$emit("input", value);
      },
      onFocus(evt) {
        this.focused = true;
        this.$emit("focus", evt);
      },
      onBlur(evt) {
        this.focused = false;
        this.$emit("blur", evt);
      },
      onKeyDown(evt) {
        this.$emit("keyDown", evt)
      },
      onkeyup(evt) {
        this.$emit("keyup", evt)
      }
    }
  };
</script>
<style>
</style>
